import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

import styles from "./StarRatingInput.module.css";

const StarRatingInput = ({
  rating,
  onChange,
  size = 30,
  readOnly = false,
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  const displayRating = readOnly ? rating : hoverRating || rating;

  return (
    <div
      className={`${styles.starRating} ${
        readOnly ? styles.starRatingReadOnly : ""
      }`}
      onMouseLeave={readOnly ? undefined : () => setHoverRating(0)}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <FaStar
          key={star}
          className={`${
            readOnly ? styles.starInputReadOnly : styles.starInput
          } ${star <= displayRating ? styles.starFilled : styles.starEmpty}`}
          size={size}
          onClick={readOnly ? undefined : () => onChange(star)}
          onMouseEnter={readOnly ? undefined : () => setHoverRating(star)}
        />
      ))}
    </div>
  );
};

export default StarRatingInput;
